module.exports = __webpack_public_path__ + "img/eagleEyeLogo.e52b6062.png";